(function(app) {

    app.provider("userApi",
    [
        function() {
            this.$get = [
                "portalApiGateway", function(portalApiGateway) {
                    var service = {};

                    service.getUserForFigAuth = function (userId) {
                        return portalApiGateway.get("/Users/FigAuth/" + userId);
                    };

                    service.get = function (userId) {
                        return portalApiGateway.get("/Users/" + userId);
                    };

                    service.getLoggedInUser = function() {
                        return portalApiGateway.get("/Users/LoggedInUser");
                    };

                    service.getFigAuth = function (userId) {
                        return portalApiGateway.get("/Users/" + userId + "/FigAuth");
                    };

                    service.getLoggedInUserPermissions = function () {
                        return portalApiGateway.get("/Users/Me/Permissions/All");
                    };

                    service.getUsersForDelegateUser = function (userId) {
                        return portalApiGateway.getArray("/Users/" + userId + "/DelegateOfUsers");
                    };

                    service.getUserToolboxFavorites = function (userId) {
                        return portalApiGateway.get("/Users/" + userId + "/ToolboxFavorites");
                    };

                    service.updateUserToolboxFavorites = function (userId, favorites) {
                        return portalApiGateway.put("/Users/" + userId + "/ToolboxFavorites", favorites);
                    };

                    service.updateOnboardingCompletedPermissions = function (userId) {
                        return portalApiGateway.put("/Users/OnboardingCompletedPermissions");
                    };

                    return service;
                }
            ];
        }
    ]);

})(window.app); //jshint ignore:line